import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = {
    key: 0,
    class: "bg-red-6 rounded",
    style: { "height": "12px", "width": "12px" }
};
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "self-center" };
const _hoisted_5 = {
    key: 0,
    class: "q-pl-xs row"
};
const _hoisted_6 = {
    key: 0,
    class: "bg-red-6 rounded",
    style: { "height": "12px", "width": "12px" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_app_multi_colored_icon = _resolveComponent("app-multi-colored-icon");
    const _component_q_item_section = _resolveComponent("q-item-section");
    const _component_app_drawer_option_list = _resolveComponent("app-drawer-option-list");
    const _component_q_expansion_item = _resolveComponent("q-expansion-item");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_generic_options = _resolveComponent("generic-options");
    return (_openBlock(), _createElementBlock("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawerOptions, (appDrawerOption, appKey) => {
            return (_openBlock(), _createElementBlock("div", { key: appKey }, [
                (_ctx.user && appKey !== 'common')
                    ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                        key: 0,
                        modelValue: _ctx.drawerOptionShow[appKey],
                        "onUpdate:modelValue": ($event) => ((_ctx.drawerOptionShow[appKey]) = $event),
                        class: "q-px-none"
                    }, {
                        header: _withCtx(() => [
                            (!_ctx.iconRight)
                                ? (_openBlock(), _createBlock(_component_q_item_section, {
                                    key: 0,
                                    avatar: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_1, [
                                            _createVNode(_component_app_multi_colored_icon, {
                                                icon: appKey,
                                                "icon-size": _ctx.appIconSize
                                            }, null, 8, ["icon", "icon-size"]),
                                            (_ctx.appBadge[appKey])
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _: 2
                                }, 1024))
                                : _createCommentVNode("", true),
                            _createVNode(_component_q_item_section, {
                                class: _normalizeClass(["text-subtitle2 quicksand-bold", {
                                        'text-accent': appKey === 'getspaces',
                                        'text-spaces-prop': appKey === 'getproperty',
                                    }])
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, _toDisplayString(appKey === "getspaces"
                                            ? _ctx.$t("flex.Flexible Rental")
                                            : _ctx.$t("property.Properties")), 1),
                                        (_ctx.iconRight)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                _createVNode(_component_app_multi_colored_icon, {
                                                    icon: appKey,
                                                    "icon-size": _ctx.appIconSize
                                                }, null, 8, ["icon", "icon-size"]),
                                                (_ctx.appBadge[appKey])
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _: 2
                            }, 1032, ["class"])
                        ]),
                        default: _withCtx(() => [
                            _createVNode(_component_app_drawer_option_list, {
                                "app-drawer-option": appDrawerOption,
                                "icon-right": _ctx.iconRight,
                                "icon-size": _ctx.iconSize
                            }, null, 8, ["app-drawer-option", "icon-right", "icon-size"])
                        ]),
                        _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true),
                ((_ctx.user &&
                    !_ctx.drawerOptionShow[appKey] &&
                    appKey !== 'common'))
                    ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
                    : _createCommentVNode("", true),
                (!_ctx.drawerOptionShow[appKey] && _ctx.user)
                    ? (_openBlock(), _createBlock(_component_app_drawer_option_list, {
                        key: 2,
                        "app-drawer-option": appDrawerOption,
                        "icon-right": _ctx.iconRight,
                        "icon-size": _ctx.iconSize,
                        "is-outer": ""
                    }, null, 8, ["app-drawer-option", "icon-right", "icon-size"]))
                    : _createCommentVNode("", true)
            ]));
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commonOptions, (value, index) => {
            return (_openBlock(), _createElementBlock("div", {
                key: value.title
            }, [
                (value.showCondition)
                    ? (_openBlock(), _createBlock(_component_generic_options, _mergeProps({
                        key: 0,
                        ref_for: true
                    }, value, {
                        "icon-right": _ctx.iconRight,
                        "icon-size": _ctx.iconSize,
                        "show-separator": index < _ctx.commonOptions.length - 1,
                        onClick: ($event) => (_ctx.action(value.title)),
                        id: `${_ctx.combineStringWithDelimiter(value.title)}-common-option`
                    }), null, 16, ["icon-right", "icon-size", "show-separator", "onClick", "id"]))
                    : _createCommentVNode("", true)
            ]));
        }), 128))
    ]));
}
